import React, { FC } from 'react';
import classnames from 'classnames';

import classes from './Tag.scss';

type Props = {
    className?: string;
    background?: 'gray' | 'orange';
};

export const Tag: FC<React.PropsWithChildren<Props>> = ({ className, children, background = 'gray' }) => (
    <div className={classnames(classes.wrapper, classes[background], className)}>{children}</div>
);
